import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {LokijsService} from './database/lokijs.service';

@Injectable({
    providedIn: 'root'
})
export class RemoveTransportLinesFromReturnService {

    constructor(private loki: LokijsService) {
    }

    findTransportPlus() {
        const transportsFuel = this.loki.getTable('producttype', '$loki')
            .chain()
            .find({$or: [{transportProductType: true}, {fuelProductType: true}]})
            .data();
        const transpFuelPluArray = [];
        for (const trans of transportsFuel) {
            transpFuelPluArray.push(trans.plu);
        }
        // console.log(transpPluArray);
        // console.log(lines);
        // lines = await lines.filter(lin => {
        //     return !transpPluArray.includes(lin.plu);
        // });
        //
        //
        // console.log(lines);
        return transpFuelPluArray;
    }
}
